import React from "react";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import ImgBannerWeb from "../../../assets/images/two-persons.jpg";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";

const Web = () => {
    return (
        <Grid fluid={true} className={"banner-web"}>
            <Row>
                <Column md={6} lg={6}>
                    <div className="container-web-content">
                        <div className="content">
                            <Row>
                                <Column>
                                    <Margin
                                        xs={[24, 0, 24, 0]}
                                        sm={[24, 0, 24, 0]}
                                        md={[24, 0, 24, 0]}
                                        lg={[24, 0, 24, 0]}
                                    >
                                        <TextHeadline component="h1" type="1">
                                            ¡Bienvenido a Scotia Wealth Management!
                                        </TextHeadline>
                                    </Margin>
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <Margin
                                        xs={[0, 0, 24, 0]}
                                        sm={[0, 0, 24, 0]}
                                        md={[0, 0, 24, 0]}
                                        lg={[0, 0, 24, 0]}
                                    >
                                        <TextSubtitle component="h2" type="1">
                                            Te asesoramos en construir soluciones globales para 
                                            la gestión de tu patrimonio.{" "}
                                        </TextSubtitle>
                                    </Margin>
                                </Column>
                            </Row>
                        </div>
                    </div>
                </Column>
                <Column md={6} lg={6}>
                    <img src={ImgBannerWeb} alt="welcome" className={"img-welcome"}/>
                </Column>
            </Row>
        </Grid>
    );
};

export default Web;
